import type { AsyncThunkApiConfig } from '@/store'
import type { RejectError } from '../../typings'

import { createAsyncThunk } from '@reduxjs/toolkit'

export const createRoadSegment = createAsyncThunk<
  // Return type of the payload creator
  string[],
  // First argument to the payload creator
  uui.domain.ui.forms.RoadSegmentCreate,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/roadSegment/create', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/roadSegment/create', {
      category: 'rpc',
      type: 'rpc/roadSegment/create',
      roadSegment: payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {create}`,
      { tags: ['rpc', 'roadSegment'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Create Road Segment failed`,
      error,
    })
  }
})
